"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var is_dev_1 = __importDefault(require("./is-dev"));
var TIZEN_LOCAL_STORAGE_KEY = 'ombori.grid.configuration';
var GENERIC_BROWSER_LOCAL_STORAGE_KEY = 'browserSettings';
var ACCESS_KEY_STORAGE_KEY = 'accessKey';
var getSettingsFromLocalStorage = function (key) {
    return window.localStorage.getItem(key);
};
var getLocalBrowserSettings = function () {
    if (is_dev_1.default)
        return null;
    var browserSettings = null;
    // For Tizen
    var tizenBrowserSettings = getSettingsFromLocalStorage(TIZEN_LOCAL_STORAGE_KEY);
    // For Generic Browser
    var genericBrowserSettings = getSettingsFromLocalStorage(GENERIC_BROWSER_LOCAL_STORAGE_KEY);
    var accessKey = getSettingsFromLocalStorage(ACCESS_KEY_STORAGE_KEY);
    console.log('tizenBrowserSettings:', tizenBrowserSettings);
    console.log('genericBrowserSettings:', genericBrowserSettings);
    if (tizenBrowserSettings) {
        browserSettings = tizenBrowserSettings;
    }
    else if (genericBrowserSettings) {
        browserSettings = genericBrowserSettings;
    }
    if (browserSettings) {
        browserSettings = JSON.parse(browserSettings);
    }
    return __assign(__assign({}, browserSettings), { accessKey: browserSettings.accessKey ? browserSettings.accessKey : accessKey });
};
exports.default = getLocalBrowserSettings;
